import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export function Datenschutz() {
  return (
    <div className="min-h-screen bg-white text-ink-900">
      <header className="border-b border-border">
        <div className="container flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-brand-gradient">
              <Heart className="h-4 w-4 text-white" fill="currentColor" />
            </span>
            <span className="text-lg font-bold tracking-tight">Parble</span>
          </Link>
          <Link to="/" className="text-sm font-semibold text-ink-500 hover:text-ink-900">
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="container max-w-3xl py-12 prose prose-neutral">
        <div className="not-prose mb-10">
          <h1 className="text-4xl font-bold tracking-tight">
            Datenschutzerklärung
          </h1>
          <p className="mt-2 text-ink-500">
            Template-Entwurf. Vor Launch durch einen Fachanwalt für IT-Recht zu
            prüfen.
          </p>
        </div>

        <h2>1. Verantwortlicher</h2>
        <p>
          Verantwortlich im Sinne der DSGVO ist der Betreiber von Parble. Die
          vollständigen Kontaktdaten findest du im{" "}
          <Link to="/legal/impressum">Impressum</Link>.
        </p>

        <h2>2. Hosting in Deutschland</h2>
        <p>
          Sämtliche Nutzerdaten werden ausschließlich auf Servern der{" "}
          <strong>Hetzner Online GmbH</strong> (Industriestr. 25, 91710
          Gunzenhausen) im Rechenzentrumsstandort <strong>Falkenstein</strong>{" "}
          bzw. <strong>Nürnberg</strong> in Deutschland verarbeitet.
          Backend, Datenbank (PostgreSQL&nbsp;16) und Foto-Uploads laufen
          innerhalb einer einzigen Hetzner-Cloud-Instanz. Es findet{" "}
          <strong>kein Transfer in Drittländer</strong> (insbesondere nicht
          in die USA) statt. Wir setzen bewusst{" "}
          <strong>kein Cloudflare, kein AWS, kein Google Cloud, kein
          Microsoft Azure</strong> ein.
        </p>

        <h2>3. Welche Daten wir verarbeiten</h2>
        <ul>
          <li>
            <strong>Account-Daten:</strong> E-Mail-Adresse, Passwort-Hash,
            Geburtstag, PLZ, Geschlecht, Vorname.
          </li>
          <li>
            <strong>Profil-Daten:</strong> Bio, Fotos, Werte-Antworten
            (15 Dimensionen auf 1–10-Skala), Suchkriterien.
          </li>
          <li>
            <strong>Nutzungsdaten:</strong> Likes, Pässe, Matches, Nachrichten,
            Deck-Sichtungen.
          </li>
          <li>
            <strong>Zahlungsdaten:</strong> werden ausschließlich vom
            Zahlungsdienstleister Stripe (EU) verarbeitet.
          </li>
        </ul>

        <h2>4. Auftragsverarbeiter (DSGVO Art. 28)</h2>
        <ul>
          <li>
            <strong>Hetzner Online GmbH</strong>, Gunzenhausen (Deutschland) —
            Hosting, Datenbank, Foto-Speicher. AV-Vertrag nach deutschem Recht.
          </li>
          <li>
            <strong>Stripe Payments Europe Ltd</strong>, Dublin (Irland) —
            ausschließlich Zahlungsabwicklung (SEPA, Karte). Kein Zugriff auf
            Match-/Chat-/Profil-Daten.
          </li>
          <li>
            <strong>Resend EU</strong> (Niederlande) — transaktionaler
            E-Mail-Versand (Verifikation, Rechnungen). Verarbeitet nur
            E-Mail-Adresse + Mail-Inhalt.
          </li>
          <li>
            <strong>Anthropic PBC</strong> (USA) — ausschließlich automatische
            Vor-Moderation von Foto-Uploads (NSFW-Klassifizierung,
            Minderjährigenverdacht). Keine Profil-, Match- oder Chat-Daten.
            Kein KI-Training mit unseren Daten (bestätigt durch API-Nutzung,
            nicht Consumer-Produkte).
          </li>
        </ul>

        <h2>5. Deine Rechte</h2>
        <ul>
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO) — in den Einstellungen mit einem Klick</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO) — Export in den Einstellungen</li>
          <li>Widerruf einer Einwilligung</li>
          <li>Beschwerde bei der Aufsichtsbehörde</li>
        </ul>

        <h2>6. KI-Nutzung</h2>
        <p>
          Wir setzen KI (Anthropic Claude) ausschließlich zur Pre-Prüfung von
          hochgeladenen Fotos (Erkennung von Nacktheit, erkennbaren Gesichtern,
          offensichtlichen Minderjährigen-Verdachtsfällen) ein. Die
          abschließende Entscheidung trifft immer ein menschlicher Moderator
          (Art. 22 DSGVO). Es findet kein Training mit Nutzerdaten statt.
        </p>

        <h2>7. Speicherdauer</h2>
        <ul>
          <li>Account-Daten: bis zur Kündigung oder Löschung.</li>
          <li>Nachrichten: Bei Account-Löschung anonymisiert, nicht gelöscht.</li>
          <li>Login-Logs: 90 Tage (berechtigtes Interesse an Betrugsabwehr).</li>
          <li>
            Deck-Einträge älter als 30 Tage werden automatisch gelöscht.
          </li>
        </ul>

        <h2>8. Kontakt für Datenschutz</h2>
        <p>Siehe <Link to="/legal/impressum">Impressum</Link>.</p>

        <p className="mt-10 text-sm text-ink-500">
          Stand: Entwurfs-Vorlage. Rechtsverbindliche Fassung folgt nach
          Anwalts-Review.
        </p>
      </main>
    </div>
  );
}
